// extracted by css-extract-rspack-plugin
export default {"moreOptionsButton":"UoR6V"};